import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getHeadingTabStyles = () => {
  return StyleSheet.create({
    headerWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start'
    },
    headerWrapperNullStartElement: {
      justifyContent: 'flex-end'
    },
    headerTextWrapper: {
      flex: 1
    },
    headerOneInfoCTAWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center'
    },
    headerOneInfoWrapper: {
      marginRight: tokens.spacing.SPACING_8,
      justifyContent: 'center'
    }
  });
};